import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { FINANCE_PORTAL_LINKS } from "../constants/financePortalLinks";
import { useRole } from "../context/RoleContext";

const FinancePortal = () => {
  const navigate = useNavigate();
  const { appUser } = useRole();
  const greeting =
    appUser?.displayName || appUser?.email || appUser?.username || "Finance";

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />
      <div className="flex-1 p-6">
        <div className="max-w-5xl mx-auto">
          <div className="mb-8 text-center sm:text-left">
            <h1 className="text-2xl font-bold text-gray-900">Finance Reports</h1>
            <p className="text-sm text-gray-600 mt-1">
              Welcome, {greeting}. Open a report below.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {FINANCE_PORTAL_LINKS.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => navigate(item.path)}
                  className="group text-left bg-white border border-gray-200 rounded-xl p-5 shadow-sm hover:shadow-md hover:border-blue-300 transition-all focus:outline-none focus:ring-2 focus:ring-blue-600"
                >
                  <div
                    className={`inline-flex items-center justify-center w-12 h-12 rounded-lg text-white mb-4 ${item.color}`}
                  >
                    <Icon className="text-xl" />
                  </div>
                  <h2 className="text-base font-semibold text-gray-900 group-hover:text-blue-900">
                    {item.title}
                  </h2>
                  <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                    {item.description}
                  </p>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancePortal;
